module.exports = __webpack_public_path__ + "img/logo@2x.44d3fd85.png";